import React from "react";
import OverviewSection from "../../components/AboutUs/Overview/OverviewSection.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";

const OverView: React.FC = () => {
  return (
    <div>
      <MetaComponent
        title="About Aptech Limited | Technical Training Institute & Vocational Education Courses"
        desc="Learn about Aptech Limited, a leading technical training institute offering globally trusted vocational education programs that empower learners with practical skills."
        keywords="Vocational training business, vocational training provider, Aptech limited, vocational training programs"
      />
      <OverviewSection />
    </div>
  );
};

export default OverView;
